<template>
    <v-card class="rounded-0" outlined>
        <v-card-title class="font-weight-bold text-h6 primary--text">
            INFORMACIÓN LABORAL
        </v-card-title>
        <v-card-text class="d-flex flex-column">
            <div class="text-body-1 font-weight-regular black--text d-flex flex-row ">
                EMPLEADOR:
                <div class="font-weight-bold ml-2 ">
                    {{ opcionNivelAfiliado.empleo }}
                </div>
            </div>
            <!--             <div class="text-body-1 font-weight-regular d-flex flex-row">
                TIPO DE EMPLEO:
                <div class="font-weight-bold ml-2">
                    {{ opcionNivelAfiliado.empleoTipo }}
                </div>
            </div> -->
            <div class="text-body-1 font-weight-regular black--text d-flex flex-row">
                EMPLEO:
                <div class="font-weight-bold ml-2">
                    {{ opcionNivelAfiliado.empleoTipo }}
                </div>
            </div>
            <div class="text-body-1 font-weight-regular black--text d-flex flex-row">
                DESDE:
                <div class="font-weight-bold ml-2">
                    {{ formatDate(opcionNivelAfiliado.empleoDesde) }}
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {

        }
    },
    computed: {
        ...mapGetters('opcionNivel', ['opcionNivelAfiliado'])
    },
    methods: {
        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
    },
}
</script>
